var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 2.33563C9.78798 2.33875 8.62627 2.82171 7.76906 3.67891C6.91186 4.53612 6.4289 5.69783 6.42578 6.9101C6.4289 8.12237 6.91186 9.28415 7.76906 10.1414C8.62627 10.9986 9.78798 11.4815 11.0002 11.4846C12.2125 11.4815 13.3742 10.9986 14.2314 10.1414C15.0886 9.28415 15.5716 8.12237 15.5747 6.9101C15.5716 5.69783 15.0886 4.53612 14.2314 3.67891C13.3742 2.82171 12.2125 2.33875 11.0002 2.33563ZM11.0002 9.52242C10.3079 9.52086 9.64436 9.24515 9.1548 8.75558C8.66524 8.26602 8.38952 7.60244 8.38796 6.9101C8.38952 6.21776 8.66524 5.55425 9.1548 5.06469C9.64436 4.57512 10.3079 4.29941 11.0002 4.29785C11.6926 4.29941 12.3561 4.57512 12.8457 5.06469C13.3353 5.55425 13.611 6.21776 13.6125 6.9101C13.6125 7.60292 13.3373 8.26742 12.8474 8.75732C12.3575 9.24722 11.6931 9.52242 11.0002 9.52242Z",
    fill: "#B2B2B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.91009C7.77306 -1.21048 14.8771 -0.725851 21 6.91009C14.8771 14.546 7.77306 15.0366 1 6.91009Z",
    stroke: "#B2B2B2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPass);
export default __webpack_public_path__ + "static/media/viewPass.0b505f2bd6d3ec806102b3491f1f25aa.svg";
export { ForwardRef as ReactComponent };